<script lang="ts">
	import { Container } from '@Shelly/shelly-design-system';
	import { _deepClone } from '../../../../helpers/utilities';
	import { onMount } from 'svelte';
	import type { IAlarmZone } from '../alarm_object';
	import DelayActionV2 from './components/DelayActionV2.svelte';
	import DelayArmActionV2 from './components/DelayArmActionV2.svelte';

	export let alarm_object: IAlarmZone = {},
		delayArmActionError: string | undefined = '',
		delayActionError: string | undefined = '';
	// export let edit: boolean;
	// export let inputAlarmMessegRef: HTMLInputElement;

	export let isActivityLogCheck: boolean;

	onMount(() => {
		//alarm_object._id is check if the scene is edited
		if (!alarm_object._id) {
			isActivityLogCheck = true;
		} else {
			isActivityLogCheck =
				alarm_object &&
				alarm_object?.do.some(({ notify }) => {
					return typeof notify !== 'undefined' && notify === 'event_log';
				});
		}
	});
</script>

<Container padding="scrollPaddings">
	<DelayArmActionV2 bind:alarm_object bind:delayArmActionError />
	<hr class="mt-l mb-l" />
	<DelayActionV2 bind:alarm_object bind:delayActionError />

	<!-- DO NOT REMOVE COMMENT: Padding references -->
	<div class="pb-s"></div>
</Container>
